var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"view_employees_body"},_vm._l((6),function(index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"auto"}},[_c('CandidateEmployeeCard',{attrs:{"show_experience":false,"employees_type":_vm.employees_type}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }